import React, { useEffect, useState } from "react";
import AcademicCalendarDisplay from "./AcademicCalendarDisplay";
import {
  getPublicCalendars,
  normalizeCalendarForDisplay,
} from "../../services/calendarServices";
import { fallbackCalendars } from "../../data/calendarFallback";

const Calendar = () => {
  const [calendars, setCalendars] = useState(fallbackCalendars);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCalendars() {
      try {
        const response = await getPublicCalendars();
        if (Array.isArray(response.data) && response.data.length > 0) {
          setCalendars(normalizeCalendarForDisplay(response.data));
        }
      } catch (err) {
        setCalendars(fallbackCalendars);
      } finally {
        setLoading(false);
      }
    }

    fetchCalendars();
  }, []);

  if (loading) {
    return (
      <div className="bg-[#F2F5F8] min-h-[50vh] flex items-center justify-center text-gray-600">
        Loading academic calendar...
      </div>
    );
  }

  return <AcademicCalendarDisplay calendars={calendars} />;
};

export default Calendar;
